import React from "react";
import { Styles } from "./styles";
import { Rating } from "@mui/material";

const ServiceCard = ({ data }) => {
  return (
    <Styles>
        <div className="title-container">

        </div>
        <div className="title-container">
          <div className="title">title: {data?.title}</div>
        </div>
        {/*<div className="description">description: {data?.description}</div>*/}

    </Styles>
  );
};

export default ServiceCard;
